import { styled } from '@mui/material/styles'
import { Switch } from '@mui/material'

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: '50px',
  height: '15px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.mixins.scrollBar.color,
      },
      '& .MuiSwitch-thumb': { backgroundColor: theme.palette.info.main },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: '26px',
    height: '13px',
    borderRadius: 10,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
    backgroundColor: theme.palette.secondary.main,
  },
  '& .MuiSwitch-track': {
    borderRadius: '10px',
    opacity: 1,
    boxSizing: 'border-box',
    backgroundColor: theme.mixins.scrollBar.color,
  },
}))
